import { useContext } from 'react'
import { LocalizationContext } from '../../contexts/localizationContext'

/**
 * Хук для использования контекста локализации
 * @returns Контекст локализации с функцией перевода и управлением языком
 * @throws Ошибка, если хук используется вне LocalizationProvider
 */
export function useLocalization() {
  const context = useContext(LocalizationContext)

  if (context === undefined) {
    throw new Error('useLocalization must be used within a LocalizationProvider')
  }

  return context
}
